import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form/immutable';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';

import FormTextFieldWithCheckbox from 'retired/FormTextFieldWithCheckbox';
import FormTextField from 'retired/FormTextField';

class FormDoubleCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: !!(
        this.props.firstFieldProps.defaultValue || this.props.secondFieldProps.defaultValue
      ),
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.firstFieldProps.defaultValue !== prevProps.firstFieldProps.defaultValue ||
      this.props.secondFieldProps.defaultValue !== prevProps.secondFieldProps.defaultValue
    ) {
      this.setState({
        showForm: !!(
          this.props.firstFieldProps.defaultValue || this.props.secondFieldProps.defaultValue
        ),
      });
    }
  }

  render() {
    return (
      <Grid container spacing={3}>
        <Grid item xs>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={this.state.showForm}
                onChange={(event, isInputChecked) => {
                  this.setState({ showForm: isInputChecked });
                  if (!isInputChecked) {
                    this.props[this.props.firstFieldProps.name].input.onChange('');
                    this.props[this.props.secondFieldProps.name].input.onChange('');
                  }
                }}
              />
            }
            label={this.props.checkboxLabel}
          />
          <Field
            component={FormTextField}
            fullWidth
            disabled={!this.state.showForm}
            {...this.props.firstFieldProps}
          />
        </Grid>
        <Grid item xs>
          <Field
            component={FormTextFieldWithCheckbox}
            disabled={!this.state.showForm}
            {...this.props.secondFieldProps}
          />
        </Grid>
        <Grid item xs />
      </Grid>
    );
  }
}

FormDoubleCheckbox.propTypes = {
  checkboxLabel: PropTypes.string,
  donationText: PropTypes.object,
  donationLink: PropTypes.object,
  firstFieldProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    hintText: PropTypes.string,
    defaultValue: PropTypes.any,
    validate: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.func), PropTypes.func]),
  }),
  secondFieldProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    hintText: PropTypes.string,
    defaultValue: PropTypes.any,
    validate: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.func), PropTypes.func]),
  }),
};

export default FormDoubleCheckbox;
